import {mountRecommendationCart} from './recommendation-cart.js?v=cologne-20261029-2';
const productCache = new Map();
const mappingCache = new Map();
const initialized = new WeakSet();
const unavailableProductHandles = (() => {
  try { return new Set(JSON.parse(document.getElementById('UiUnavailableProducts')?.textContent || '{}').handles || []); }
  catch { return new Set(); }
})();
function verifiedReplacements(mapping) {return (mapping?.replacements||[]).filter(r=>r.status==='verified');}
const fallbackMaintenance = [
  {handle:'andis-12501-clipper-oil-4oz-133',product_id:'10903228645660',relation:'maintenance',usage:'blade_oil',status:'curated'},
  {handle:'andis-blade-brush-984',product_id:'10903228580124',relation:'maintenance',usage:'cleaning_brush',status:'curated'}
];
function randomItem(items) {return items[Math.floor(Math.random()*items.length)];}

export function eligibleRelationships(mapping, variantId) {
  if (!mapping || !mapping.source_variant_ids.includes(String(variantId))) return [];
  const companions = mapping.show_all_companions
    ? mapping.visible_companion_handles
      ? mapping.visible_companion_handles.map(handle=>mapping.companions.find(r=>r.handle===handle)).filter(Boolean)
      : mapping.companions
    : mapping.companions.slice(0, 1);
  return [...verifiedReplacements(mapping), ...companions, ...mapping.maintenance].filter(r=>r.status==='verified'||r.status==='curated');
}
export function cartHasTool(cart, productId, bundles={}) {
  return (cart?.items||[]).some(item=>String(item.product_id)===String(productId)||(bundles[item.handle]||[]).includes(String(productId)));
}
export function priceTier(sourcePrice, companionPrice, windowPercent=25) {
  if(sourcePrice<=0) return 'curated';
  const ratio=companionPrice/sourcePrice;
  return ratio>1+windowPercent/100?'step_up':ratio<1-windowPercent/100?'lower_price':'similar_price';
}

function element(tag, className='', text='') {
  const node=document.createElement(tag);
  node.className=className;
  node.textContent=text;
  return node;
}
function displayTitle(title) {return title;}
async function json(url, options={}) {
  const readOnly = !options.method || options.method.toUpperCase() === 'GET';
  const attempts = readOnly ? 2 : 1;
  for (let attempt = 0; attempt < attempts; attempt++) {
    let response;
    try {
      response = await fetch(url, {...options, credentials:'same-origin', signal:AbortSignal.timeout(12000)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Request failed');
      return data;
    } catch (error) {
      const permanent = response && response.status >= 400 && response.status < 500 && response.status !== 429;
      if (attempt + 1 === attempts || permanent) throw error;
      await new Promise(resolve => setTimeout(resolve, 300));
    }
  }
}
function mappingData(url) {
  if(!mappingCache.has(url)) mappingCache.set(url,json(url).catch(error=>{mappingCache.delete(url);throw error;}));
  return mappingCache.get(url);
}
function productData(root, handle) {
  if(!/^[a-z0-9-]+$/.test(handle)) return Promise.reject(new Error('Invalid product handle'));
  const url=`${root}products/${handle}.js`;
  if(!productCache.has(url)) productCache.set(url,json(url).then(product=>unavailableProductHandles.has(handle)
    ? {...product,available:false,variants:product.variants.map(variant=>({...variant,available:false}))}
    : product).catch(error=>{productCache.delete(url);throw error;}));
  return productCache.get(url);
}

async function initialize(section) {
  if(initialized.has(section)) return;
  initialized.add(section);
  const strings=JSON.parse(section.querySelector('[data-setup-strings]').textContent);
  const text=(key,values={})=>Object.entries(values).reduce((result,[k,v])=>result.replaceAll(`%${k}%`,String(v)),strings[key]||key);
  const root=section.dataset.root||'/';
  const status=section.querySelector('[data-setup-status]');
  const grid=section.querySelector('[data-setup-grid]');
  const isFinder=section.hasAttribute('data-parts-finder');
  const currency=section.dataset.currency||'USD';
  const money=amount=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(amount/100);
  const data=await mappingData(section.dataset.mappingUrl);
  let cart=null;
  try {cart=await json(`${root}cart.js`);} catch {}
  let generation=0;
  let activeMapping=null;
  let variantId=null;
  let sourcePrice=0;
  let ownCartMutation=false;
  let companionSelect=null;

  function setStatus(message) {status.textContent=message;}
  function emit(name,detail) {
    section.dispatchEvent(new CustomEvent(name,{bubbles:true,detail}));
  }
  async function addProduct(product, variant, button, onAdded) {
    const now=Date.now();
    if(button.disabled||!variant.available||now-Number(button.dataset.lastAttempt||0)<750) return;
    button.dataset.lastAttempt=String(now);
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent=text('adding');
    let added=false;
    try {
      await json(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      added=true;
      setStatus(text('added',{product:displayTitle(product.title)}));
      emit('setup:added',{source_product_id:activeMapping?.source_id,recommended_product_id:String(product.id),variant_id:String(variant.id),quantity:1,product_title:displayTitle(product.title)});
      try {
        cart=await json(`${root}cart.js`);
        document.querySelectorAll('.cart-link').forEach(link=>{link.textContent=text('cart',{count:cart.item_count});});
        ownCartMutation=true;
        document.dispatchEvent(new CustomEvent('setup:cart-updated',{detail:cart}));
        ownCartMutation=false;
      } catch {}
      if(onAdded) {try {await onAdded();} catch {setStatus(text('added_parts_error',{product:displayTitle(product.title)}));}}
    } catch {
      setStatus(text('add_error'));
    } finally {
      button.removeAttribute('aria-busy');
      const suppress=added&&['Clipper','Trimmer','Shaver'].includes(product.type);
      button.disabled=suppress;
      button.textContent=suppress?text('in_cart'):text('add');
    }
  }

    async function card(relationship, sourceMapping, nested=false) {
    if(relationship.relation==='replacement'&&relationship.status!=='verified')return null;
    const product=await productData(root,relationship.handle);
    const productTitle=displayTitle(product.title);
    if(relationship.product_id&&String(product.id)!==relationship.product_id) return null;
    if(relationship.relation!=='replacement'&&!product.variants.some(v=>v.available))return null;
    const node=element(nested?'div':'article',nested?'setup-child':'product-card setup-card');
    node.dataset.relationship=relationship.relation;
    node.dataset.recommendedHandle=product.handle;
    node.dataset.recommendedProductId=String(product.id);
    const label=relationship.relation==='extra'?'extra_'+relationship.category:relationship.relation==='replacement'?'replacement':relationship.relation==='maintenance'?'maintenance':relationship.relation==='matching'?'matching':relationship.cross_brand?'professional':'curated';
    node.append(element('span','setup-badge',relationship.label||text(label)));
    const link=element('a','setup-product-link');
    link.href=`${root}products/${product.handle}`;
    if(product.featured_image) {
      const image=element('img');
      const imageUrl=new URL(product.featured_image,location.origin);
      if(!['https:','http:'].includes(imageUrl.protocol)) return null;
      imageUrl.searchParams.set('width','500');
      image.src=imageUrl.toString();image.alt=productTitle;image.loading='lazy';image.width=500;image.height=500;
      link.append(image);
    }
    link.append(element(nested?'h4':'h3','',productTitle));
    link.addEventListener('click',()=>emit('setup:click',{source_product_id:sourceMapping.source_id,recommended_product_id:String(product.id),relation:relationship.relation}));
    node.append(link);
    const description=element('div','setup-description');
    if(relationship.reason) description.append(element('p','',relationship.reason));
    else if(relationship.relation==='extra') description.append(element('p','',text('extra_'+relationship.category+'_reason')));
    else if(relationship.relation==='replacement') description.append(element('p','',text('replacement_reason',{model:displayTitle(sourceMapping.title)})));
    else if(relationship.relation==='matching') description.append(element('p','',text('matching_reason',{family:relationship.family})));
    else if(relationship.relation==='maintenance') description.append(element('p','',text(relationship.usage==='cleaning_brush'?'brush_reason':'maintenance_reason')));
    else description.append(element('p','',text(relationship.cross_brand?'professional_reason':'curated_reason',{brand:relationship.cross_brand?product.vendor:sourceMapping.brand,type:product.type.toLowerCase()})));
    if(relationship.usage==='prepare_for_shaving')description.append(element('p','',text('shaving_reason')));
    if(relationship.usage==='finish_after_trimming')description.append(element('p','',text('finishing_reason')));
    if(relationship.usage==='facial_finishing')description.append(element('p','',text('facial_reason')));
    node.append(description);
    const price=element('p','setup-price');node.append(price);
    mountRecommendationCart(node,product,{root,currency,price,link,sourceSection:section});
    return node;
  }

  const nav=element('div','setup-carousel-nav');
  const previous=element('button','setup-carousel-arrow','‹');previous.type='button';previous.setAttribute('aria-label',text('previous_suggestion'));
  const next=element('button','setup-carousel-arrow','›');next.type='button';next.setAttribute('aria-label',text('next_suggestion'));
  const position=element('span','setup-carousel-position');
  grid.id=grid.id||'SetupGrid-'+(section.dataset.productId||section.id||'finder');grid.tabIndex=0;grid.setAttribute('aria-label',text('suggestions_label'));
  previous.setAttribute('aria-controls',grid.id);next.setAttribute('aria-controls',grid.id);
  nav.append(previous,position,next);grid.before(nav);
  function updateCarousel(){
    const count=grid.children.length;const max=grid.scrollWidth-grid.clientWidth;
    const offset=Math.abs(grid.scrollLeft);const first=grid.firstElementChild;
    const step=first?first.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).columnGap||0):1;
    previous.disabled=offset<=2;next.disabled=max<=2||offset>=max-2;
    position.textContent=count?text('suggestion_position',{current:Math.min(count,Math.round(offset/step)+1),total:count}):'';
    nav.hidden=count<2;
  }
  function moveCarousel(direction){
    const first=grid.firstElementChild;if(!first)return;
    const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).columnGap||0);
    const rtl=getComputedStyle(grid).direction==='rtl'?-1:1;
    grid.scrollBy({left:direction*step*rtl,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  previous.addEventListener('click',()=>moveCarousel(-1));next.addEventListener('click',()=>moveCarousel(1));
  grid.addEventListener('scroll',updateCarousel,{passive:true});
  grid.addEventListener('keydown',event=>{if(event.target!==grid)return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();moveCarousel(event.key==='ArrowLeft'?-1:1);}});
  new ResizeObserver(updateCarousel).observe(grid);

  async function render(mapping, partsOnly=false) {
    const request=++generation;
    activeMapping=mapping;
    grid.replaceChildren();
    if(!mapping) return;
    let relationships=partsOnly?verifiedReplacements(mapping):eligibleRelationships(mapping,variantId);
    if(!partsOnly) {
      const nonMaintenance=relationships.filter(r=>r.relation!=='maintenance');
      const maintenancePool=relationships.filter(r=>r.relation==='maintenance');
      const suitableFallback=mapping.skip_maintenance_fallback?[]:mapping.type==='Shaver'?fallbackMaintenance.filter(r=>r.usage==='cleaning_brush'):fallbackMaintenance;
      const maintenance=randomItem(maintenancePool.length?maintenancePool:suitableFallback);
      relationships=section.dataset.extrasUrl?nonMaintenance:maintenance?[...nonMaintenance,maintenance]:nonMaintenance;
      const selectedCompanion=companionSelect?.value;
      if(selectedCompanion) relationships=relationships.map(r=>['matching','curated'].includes(r.relation)?mapping.companions.find(c=>c.handle===companionSelect.selectedOptions[0]?.dataset.handle)||r:r);
    }
    if(!relationships.length) {
      if(partsOnly) setStatus(text('no_parts'));
      else section.hidden=true;
      return;
    }
    section.hidden=false;
    const partsHelp=section.querySelector('[data-setup-parts-help]');
    if(partsHelp)partsHelp.hidden=verifiedReplacements(mapping).length>0;
    setStatus(text('loading'));
    grid.setAttribute('aria-busy','true');
    const results=await Promise.allSettled(relationships.map(r=>card(r,mapping)));
    if(request!==generation) return;
    for(const result of results) if(result.status==='fulfilled'&&result.value) grid.append(result.value);
    grid.removeAttribute('aria-busy');
    setStatus(results.some(r=>r.status==='rejected')?text('load_error'):grid.children.length?'':(relationships.some(r=>cartHasTool(cart,r.product_id,data.bundle_contents))?text('already_covered'):'No other available suggestion is shown right now.'));
    updateCarousel();
    emit('setup:impression',{source_product_id:mapping.source_id,recommendations:Array.from(grid.children).map(n=>n.dataset.recommendedHandle)});
  }

  async function renderExtras(){
    if(isFinder||!section.dataset.extrasUrl||!activeMapping)return;
    const pools=await json(section.dataset.extrasUrl);
    const excluded=new Set([section.dataset.productHandle,...eligibleRelationships(activeMapping,variantId).map(r=>r.handle)]);
    const wrap=element('div','setup-extras');wrap.hidden=true;
    const heading=element('h3','',text('extras_heading'));wrap.append(heading,element('p','setup-extras-intro',text('extras_intro')));
    const extras=element('div','product-grid setup-grid setup-extra-grid');extras.id=`SetupExtras-${section.dataset.productId}`;extras.setAttribute('aria-label',text('extras_heading'));extras.tabIndex=0;wrap.append(extras);grid.after(wrap);
    const chosen=await Promise.all(Object.entries(pools.categories).filter(([category])=>!activeMapping.extra_categories||activeMapping.extra_categories.includes(category)).map(async([category,pool])=>{
      const shuffled=pool.filter(p=>!excluded.has(p.handle));
      for(let i=shuffled.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[shuffled[i],shuffled[j]]=[shuffled[j],shuffled[i]];}
      for(const candidate of shuffled.slice(0,8)){
        try{const product=await productData(root,candidate.handle);if(String(product.id)!==candidate.product_id||!product.variants.some(v=>v.available)||cartHasTool(cart,product.id,data.bundle_contents))continue;return await card({handle:candidate.handle,product_id:candidate.product_id,relation:'extra',category,status:'curated'},activeMapping);}catch{}
      }
      return null;
    }));
    chosen.filter(Boolean).forEach(card=>extras.append(card));
    if(!extras.children.length){wrap.remove();return;}
    wrap.hidden=false;
    const extraNav=element('div','setup-carousel-nav setup-extras-nav');
    const prev=element('button','setup-carousel-arrow','‹');prev.type='button';prev.setAttribute('aria-label',text('previous_suggestion'));prev.setAttribute('aria-controls',extras.id);
    const next=element('button','setup-carousel-arrow','›');next.type='button';next.setAttribute('aria-label',text('next_suggestion'));next.setAttribute('aria-controls',extras.id);
    const position=element('span','setup-carousel-position');extraNav.append(prev,position,next);extras.before(extraNav);
    function step(){return extras.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(extras).columnGap||0);}
    function update(){const max=extras.scrollWidth-extras.clientWidth,offset=Math.abs(extras.scrollLeft);extraNav.hidden=max<=2;prev.disabled=offset<=2;next.disabled=offset>=max-2;position.textContent=text('suggestion_position',{current:Math.min(extras.children.length,Math.round(offset/step())+1),total:extras.children.length});}
    function move(direction){extras.scrollBy({left:direction*step()*(getComputedStyle(extras).direction==='rtl'?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));extras.addEventListener('scroll',update,{passive:true});extras.addEventListener('keydown',event=>{if(event.target!==extras)return;if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}});new ResizeObserver(update).observe(extras);update();
  }

  if(isFinder) {
    const brand=section.querySelector('[data-finder-brand]'),model=section.querySelector('[data-finder-model]');
    brand.replaceChildren();
    const all=element('option','',text('all_brands'));all.value='';brand.append(all);
    const entries=Object.values(data.mappings).sort((a,b)=>a.title.localeCompare(b.title));
    const brands=new Map(entries.map(m=>[m.brand.toLowerCase(),m.brand.toLowerCase()==='stylecraft'?'StyleCraft':m.brand]));
    [...brands.entries()].sort((a,b)=>a[1].localeCompare(b[1])).forEach(([key,name])=>{const option=element('option','',name);option.value=key;brand.append(option);});
    function models() {
      model.replaceChildren();const empty=element('option','',text('choose_model'));empty.value='';model.append(empty);
      entries.filter(m=>!brand.value||m.brand.toLowerCase()===brand.value).forEach(m=>{const option=element('option','',displayTitle(m.title));option.value=Object.keys(data.mappings).find(h=>data.mappings[h]===m);model.append(option);});
      grid.replaceChildren();grid.removeAttribute('aria-busy');setStatus('');
    }
    models();brand.disabled=false;model.disabled=false;section.querySelector('[data-finder-submit]').disabled=false;
    brand.addEventListener('change',()=>{generation++;models();});
    model.addEventListener('change',()=>{generation++;grid.replaceChildren();grid.removeAttribute('aria-busy');setStatus('');});
    section.querySelector('[data-finder-form]').addEventListener('submit',async event=>{
      event.preventDefault();
      const selectedHandle=model.value;
      const mapping=data.mappings[selectedHandle];
      if(!mapping) return;
      await render(mapping,true);
      if(model.value!==selectedHandle) return;
      const toolLink=element('a','',text('view_tool'));toolLink.href=`${root}products/${selectedHandle}`;
      status.append(document.createTextNode(' '),toolLink);
      if(!verifiedReplacements(mapping).length) {const help=element('a','',text('contact'));help.href='mailto:Support@1-800-BarberSupply.com';status.append(document.createTextNode(' '),help);}
    });
  } else {
    const mapping=data.mappings[section.dataset.productHandle];
    if(!mapping||mapping.source_id!==section.dataset.productId) return;
    const variantSelect=document.querySelector('.product-form [name="id"]');
    variantId=variantSelect?.value;
    const source=await productData(root,section.dataset.productHandle);
    function selectedPrice() {sourcePrice=source.variants.find(v=>String(v.id)===String(variantId))?.price||source.price;}
    selectedPrice();
    const form=variantSelect?.closest('form');
    if(form&&mapping.companions.length&&(mapping.companions.length>1&&!mapping.show_all_companions||mapping.optional_companion)) {
      const choices=element('details','setup-companion-purchase');
      const disclosure=element('summary','setup-companion-summary');
      const disclosureText=element('span','setup-companion-summary-text',text('pairing_optional'));
      const currentChoice=element('span','setup-companion-current');currentChoice.hidden=true;disclosureText.append(currentChoice);disclosure.append(disclosureText);
      choices.append(disclosure);
      const fieldset=element('fieldset','setup-companion-fieldset');
      fieldset.setAttribute('aria-label',text('pairing_optional'));
      const options=element('div','setup-companion-options');
      const select=element('select');companionSelect=select;select.hidden=true;
      select.id=`SetupCompanion-${section.dataset.productId}`;select.dataset.companionChoice='';
      const none=element('option','',text('no_companion'));none.value='';select.append(none);
      function choice(option,product,variant){
        const label=element('label','setup-companion-option');
        const radio=element('input');radio.type='radio';radio.name=`SetupCompanionChoice-${section.dataset.productId}`;radio.value=option.value;radio.checked=!option.value;radio.disabled=option.disabled;
        let image=element('span','setup-companion-placeholder','—');image.setAttribute('aria-hidden','true');
        const src=variant?.featured_image?.src||product?.featured_image;
        if(src){const imageUrl=new URL(src,location.origin);if(['https:','http:'].includes(imageUrl.protocol)){image=element('img');imageUrl.searchParams.set('width','128');image.src=imageUrl.toString();image.alt='';image.width=64;image.height=64;image.loading='lazy';}}
        const detail=element('span','setup-companion-detail');
        detail.append(element('span','setup-companion-name',product?displayTitle(product.title):text('no_companion')));
        if(product&&product.variants.length>1)detail.append(element('span','setup-companion-variant',variant.title));
        if(variant)detail.append(element('span','setup-companion-price',`+${money(variant.price)}${variant.available?'':' ('+text('unavailable')+')'}`));
        label.append(radio,image,detail);options.append(label);
        radio.addEventListener('change',()=>{select.value=radio.value;updatePurchase();render(mapping);});
      }
      choice(none);
      for(const companion of mapping.companions){
        const companionProduct=await productData(root,companion.handle);
        for(const variant of companionProduct.variants){
          const title=companionProduct.title+(companionProduct.variants.length>1?' — '+variant.title:'');
          const option=element('option','',`${title} — +${money(variant.price)}`);
          option.value=String(variant.id);option.dataset.handle=companion.handle;option.dataset.price=String(variant.price);option.disabled=!variant.available;select.append(option);
          choice(option,companionProduct,variant);
        }
      }
      const id=element('input');id.type='hidden';id.name='shopify-additional-items[1][id]';id.disabled=true;
      const quantity=element('input');quantity.type='hidden';quantity.name='shopify-additional-items[1][quantity]';quantity.disabled=true;
      // The visual choice sits in suggestions; purchase fields stay in the real product form.
      form.append(id,quantity);
      const summary=element('p','setup-order-summary');summary.setAttribute('role','status');summary.setAttribute('aria-live','polite');
      const note=element('p','setup-purchase-note',text('companion_note'));
      const purchase=element('button','button setup-companion-submit',text('add_both'));purchase.type='submit';purchase.setAttribute('form',form.getAttribute('id'));purchase.hidden=true;purchase.disabled=true;
      fieldset.append(options);choices.append(fieldset,select,note,summary,purchase);nav.before(choices);
      const submit=form.querySelector('button[type="submit"]');
      const baseLabel=submit.textContent;
      function updatePurchase(){
        const count=Math.max(1,parseInt(form.querySelector('[name="quantity"]')?.value,10)||1);
        const option=select.selectedOptions[0];const chosen=!!select.value;
        id.disabled=quantity.disabled=!chosen;id.value=select.value;quantity.value=String(count);
        currentChoice.hidden=!chosen;currentChoice.textContent=chosen?option.textContent:'';
        const total=(sourcePrice+(chosen?Number(option.dataset.price):0))*count;
        summary.textContent=text('order_total',{total:money(total)})+(chosen?' '+text('companion_cost',{price:money(Number(option.dataset.price)),quantity:count}):'');
        purchase.hidden=!chosen;
        if(form.dataset.cartSubmitting!=='true'){submit.textContent=chosen?text('add_both'):baseLabel;purchase.textContent=text('add_both');purchase.disabled=!chosen;}
      }
      select.addEventListener('change',()=>{options.querySelectorAll('input[type="radio"]').forEach(r=>r.checked=r.value===select.value);updatePurchase();render(mapping);});
      form.querySelector('[name="quantity"]')?.addEventListener('input',updatePurchase);
      variantSelect.addEventListener('change',()=>{variantId=variantSelect.value;selectedPrice();updatePurchase();});
      updatePurchase();
    }
    variantSelect?.addEventListener('change',()=>{variantId=variantSelect.value;selectedPrice();render(mapping);});
    document.addEventListener('setup:cart-updated',event=>{cart=event.detail;if(!ownCartMutation)render(mapping);});
    await render(mapping);
    renderExtras().catch(error=>{console.error("Station recommendations failed",error);setStatus(text("load_error"));});
  }
}

function boot(scope=document) {
  scope.querySelectorAll('[data-setup-preview], [data-parts-finder]').forEach(section=>{
    initialize(section).catch(error=>{
  console.error('Product recommendations failed', error);
  section.hidden = false;
  const status = section.querySelector('[data-setup-status]');
  const strings = JSON.parse(section.querySelector('[data-setup-strings]').textContent);
  if (status) status.textContent = strings.load_error;
});
  });
}
if(typeof document!=='undefined') {
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot()); else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
}
